import ToggleSwitch from "./Switch";
import './switch.scss';

export default ToggleSwitch;